import { GetB2bOrderDetailsResponse } from '@Common/types/b2b/orders';
import { OrderInitiator } from '@Common/types/bo/orders/common';

export const ordersTranslations = {
  fields: {
    id: 'Order ID',
    employee_id: 'Employee ID',
    instrument_id: 'Instrument ID',
    company_id: 'Company ID',
    user_id: 'User ID',
    b2b_individual_operation_id: 'Individual Operation ID',
    side: 'Side',
    quantity: 'Quantity',
    short_name: 'Short name',
    isin: 'ISIN',
    operation: 'Operation',
    user_currency: 'User Currency',
    status: 'Status',
    user_currency_amount: 'Filled Amount',
    user_currency_amount_input: 'Amount',
    net_amount: 'Net amount',
    total_gross_amount: 'Gross amount',
    filled_quantity: 'Filled Quantity',
    b2b_company_plan_id: 'Plan ID',
    od_orders_aggregated_id: 'Aggregated Order ID',
    recurring_fee_charge_id: 'Recurring Fee Charge ID',
    b2b_recurring_investment_id: 'B2B Recurring Investment ID',
    contract_id: 'Contract ID',
    created_at: 'Created At',
    updated_at: 'Updated At',
    linked_transfer_id: 'Linked Transfer ID',
    files: 'Document Files',
    is_matching_contribution: 'Is Matching Contribution',
    matching_contribution_pool_year: 'Matching contribution pool year',
    tax_amount: 'Tax Amount',
    tax_info: 'Tax Info',
    fee_amount: 'Total fee amount impacted on order',
    entry_fee_amount: 'Entry fee amount',
    entry_fee_company_amount: 'Company entry fee amount',
    entry_fee_employee_amount: 'Employee entry fee amount',
    entry_fee_rate: 'Entry fee rate',
    shares_fee_amount: 'Shares fee amount',
    fee_info: 'Fee info',
    matched_contribution_order_id: 'Linked Order ID',
    matching_contribution_order_id: 'Matching Contribution Order ID',
    savings_funds_requests_id: 'Funds Request ID',
    filled_avg_price: 'Avg Price',
    instrument_currency: 'Currency',
    campaign_id: 'Operation ID',
    oddo_status: 'Oddo status',
    correlation_id: 'Correlation ID',
    initiator: 'Order initiator',
    reference_uuid: 'Reference UUID',
    b2b_withdrawal_id: 'Withdrawal ID',
    trade_confirmation_document_id: 'Trade Confirmation',
    arbitrage_sell_order_id: 'Arbitrage Sell Order ID',
    b2b_transfer_request_id: 'Transfer Request ID',
    passive_price_reference_at: 'Passive NAV Trigger At',
    passive_nav_date_at: 'Passive NAV At',
    rejected_code: 'Rejection code',
    rejected_description: 'Rejection description',
    passive_nav_source: 'Source of NAV',
    filled_at: 'Filled at',
    corrected_od_order_id: 'Corrected Order ID',
    cancellation_reason: 'Cancellation reason',
    cancellation_initiator: 'Cancellation initiator',
    canceled_at: 'Cancelled at',
    internal_note: 'Internal note',
  } satisfies Record<
    keyof Omit<
      GetB2bOrderDetailsResponse,
      | 'is_cancelable'
      | 'qty_decimal_places'
      | 'correction_orders'
      | 'ledger_corrections'
      | 'effective_state'
      | 'passive_nav_calculation'
    >,
    string
  >,
  sections: {
    details: 'Details',
    execution: 'Execution',
    matching_contribution: 'Matching contribution',
    other: 'Other',
  },
  choices: {
    initiator: {
      shares: 'Shares',
      user: 'User',
      broker: 'Broker',
      bo: 'Backoffice User',
    } satisfies Record<OrderInitiator, string>,
  },
};
